<template>
  <div
    class="modal fade"
    id="viewRankTypeModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="viewRankTypeModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <form
        class="modal-content"
        @submit="editRankType"
      >
        <div class="modal-header">
          <h5
            class="modal-title font-weight-bolder"
            id="viewRankTypeModalLabel"
          >
            RANK TYPE DETAILS
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div
            class="form-group row"
            :class="{'has-error': errorUpdate.code !== ''}"
          >
            <label
              for="rankTypeCode"
              class="col-sm-2 col-form-label font-weight-bolder"
            >
              CODE:
            </label>
            <div class="col col-sm-10">
              <input
                type="text"
                class="form-control form-control-xs"
                id="rankTypeCode"
                maxlength="10"
                required
                v-model="rankType.code"
                :readonly="!editable"
                @input="capitalize($event, rankType, 'code')"
              >
              <span
                class="help-block"
                v-if="errorUpdate.code !== ''"
              >
                <small><strong>{{ errorUpdate.code }}</strong></small>
              </span>
            </div>
          </div>

          <div
            class="form-group row"
            :class="{'has-error': errorUpdate.name !== ''}"
          >
            <label
              for="rankTypeName"
              class="col-sm-2 col-form-label font-weight-bolder"
            >NAME:</label>
            <div class="col col-sm-10">
              <input
                type="text"
                class="form-control form-control-xs"
                id="rankTypeName"
                maxlength="25"
                required
                v-model="rankType.name"
                :readonly="!editable"
                @input="capitalize($event, rankType, 'name')"
              >
              <span
                class="help-block"
                v-if="errorUpdate.name !== ''"
              >
                <small><strong>{{ errorUpdate.name }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row">
            <label
              for="status"
              class="col-sm-2 col-form-label font-weight-bolder"
            >STATUS:</label>
            <div class="col col-sm-2">
              <input
                type="checkbox"
                name="status"
                id="status"
                class="form-control form-control-xs"
                v-model="rankType.status"
                :disabled="!editable"
              >
            </div>
            <div class="col col-sm-2">
              <label class="col-sm-2 col-form-label">{{ rankType.status ? 'ACTIVE':'INACTIVE' }}</label>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-sm btn-warning font-weight-bolder"
          >
            <span><i class="fas fa-edit" /></span>
            {{ editable ? 'UPDATE':'EDIT' }}
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary font-weight-bolder"
            @click="cancelEdit"
            id="cancelButton"
          >
            <span><i class="fas fa-ban" /></span>
            {{ editable ?'CANCEL': 'CLOSE' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from "../../../mixins/formMixins";
    export default {
        mixins: [formMixins],
        name: 'ViewRankTypes',
        methods: {
            ...mapActions(['setEditable', 'updateRankType']),
            async editRankType(e) {
                e.preventDefault();
                if(this.editable) {
                    if (await this.confirmUpdateAlert('Are you sure you want to update this rank type?')) {
                        if (await this.updateRankType(this.rankType)) {
                            this.successAlert('Rank Successfully Updated', 'UPDATE');

                        } else {
                            this.errorAlert(this.generateErrorMessage(this.errorUpdate), 'UPDATE');

                        }
                    }
                }
                this.setEditable();
            },

            cancelEdit() {
                let cancelButton = document.getElementById('cancelButton');
                if(this.editable) {
                    this.setEditable();
                    cancelButton.removeAttribute('data-dismiss');
                    cancelButton.removeAttribute('data-target');
                } else {
                    cancelButton.setAttribute('data-dismiss', 'modal');
                    cancelButton.setAttribute('data-target', '#viewRankTypeModal');
                }
            }
        },
        computed: {
            ...mapGetters([
                'rankType',
                'editable',
                'errorUpdate'
            ])
        }
    };
</script>

<style scoped>

</style>
